import { render, staticRenderFns } from "./ym-profit-page-detailed.vue?vue&type=template&id=56673ee7&scoped=true&"
import script from "./ym-profit-page-detailed.vue?vue&type=script&lang=js&"
export * from "./ym-profit-page-detailed.vue?vue&type=script&lang=js&"
import style0 from "./ym-profit-page-detailed.vue?vue&type=style&index=0&id=56673ee7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56673ee7",
  null
  
)

export default component.exports